import script from "./Recipient.vue?vue&type=script&setup=true&lang=js"
export * from "./Recipient.vue?vue&type=script&setup=true&lang=js"

import "./Recipient.vue?vue&type=style&index=0&id=31a61542&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31a61542"]])

export default __exports__